import { render, staticRenderFns } from "./AddictiveStuffClientFloatBtns.vue?vue&type=template&id=87beafbe&"
import script from "./AddictiveStuffClientFloatBtns.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports